module.exports = __webpack_public_path__ + "img/icon-location.348b3783.svg";